import _ from 'lodash';

import { removeFromCart, updateCartItemQuantity } from '../api/store-api';
import App from '../classes/app';
import Component from '../classes/component';
import CartSummary from './cart-summary';
import { CartSummary as CartSummaryType } from '../types/store-types';
import QuantitySelector from './quantity-selector';
import CartCount from './cart-count';

const SELECTORS = {
  removeBtn: '.remove-btn',
};

class CartItem extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _quantitySelector: QuantitySelector;

  private _cartSummary: CartSummary;

  private get _itemKey() {
    return this.container.dataset.itemKey;
  }

  private _updateView(cartSummary: CartSummaryType) {
    if (_.isEmpty(cartSummary.items)) {
      document.querySelector('.cart').classList.add('is-empty');
    } else {
      this._cartSummary.updateContent(cartSummary);
    }

    App.getComponentsOfType<CartCount>('cart-count').forEach(cartCount => {
      cartCount.updateCount(cartSummary.items_count);
    });
  }

  private async _handleRemove() {
    this._cartSummary.blockUi();
    this._getChild('removeBtn').classList.add('is-loading');
    const res = await removeFromCart({ item_key: this._itemKey });
    if (res.success) {
      this._destroy();
      this._updateView(res.data);
    }
    this._getChild('removeBtn').classList.remove('is-loading');
    this._cartSummary.unblockUi();
  }

  private async _handleQuantityChange(quantity: number) {
    this._quantitySelector.disable();
    this._cartSummary.blockUi();
    const res = await updateCartItemQuantity({ item_key: this._itemKey, quantity });
    if (res.success) {
      this._updateView(res.data);
      if (quantity !== this._quantitySelector.value) {
        this._quantitySelector.value = quantity;
      }
    }
    this._cartSummary.unblockUi();
    this._quantitySelector.enable();
  }

  protected _onEnter() {
    this._quantitySelector = this._getChildComponent<QuantitySelector>('quantity-selector');
    [this._cartSummary] = App.getComponentsOfType<CartSummary>('cart-summary');

    this._quantitySelector.addChangeListener(this._handleQuantityChange.bind(this), 500);
    this._addListener('removeBtn', 'click', this._handleRemove, 200);
  }
}

export default CartItem;
